import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_New extends QuestionPassState {
    id = QuestionPassStateId.New;
    name = 'Noch nicht beantwortet';
    color = '';
    orderInProgressbar = 1;
}
